import { all, put, call, takeLatest } from 'redux-saga/effects'

import { request } from '../../services/client'
import { ActionTypes } from '../constants/actions';
import { APIEndpoints } from '../constants';

export function* getCompanyList(action) {
  try {
    const response = yield call(request, APIEndpoints.LIST_COMPANIES, {
      method: 'GET',
      payload: {...action.payload.filter}
    })
    yield put({
      type: ActionTypes.GET_COMPANY_LIST_SUCCESS,
      payload: response.companies
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_COMPANY_LIST_FAILURE,
      payload: err.message
    })
  }
}

export function* getCompanyDetails(action) {
  try {
    const { companyId } = action.payload
    const response = yield call(request, APIEndpoints.GET_COMPANY_DETAILS(companyId), {
      method: 'GET',
    })
    yield put({
      type: ActionTypes.GET_COMPANY_DETAILS_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_COMPANY_DETAILS_FAILURE,
      payload: err.message
    })
  }
}

export function* getCompanyAuditHistory(action) {
  try {
    const { companyId } = action.payload
    const response = yield call(request, APIEndpoints.GET_COMPANY_AUDIT_HISTORY(companyId), {
      method: 'GET',
    })
    yield put({
      type: ActionTypes.GET_COMPANY_AUDIT_HISTORY_SUCCESS,
      payload: response.company_audit_history
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_COMPANY_AUDIT_HISTORY_FAILURE,
      payload: err.message
    })
  }
}

export function* getCompanyAuditDetails(action) {
  try {
    const { companyId, auditId, year } = action.payload;
    const payload = {};
    if(year) {
      payload.year = year;
    } else {
      payload.audit_status_id = auditId;
    }
    const response = yield call(request, APIEndpoints.GET_COMPANY_AUDIT_DETAILS(companyId), {
      method: 'GET',
      payload
    })
    yield put({
      type: ActionTypes.GET_COMPANY_AUDIT_DETAILS_SUCCESS,
        payload: response
      })
    } catch (err) {
      /* istanbul ignore next */
      yield put({
        type: ActionTypes.GET_COMPANY_AUDIT_DETAILS_FAILURE,
        payload: err.message
      })
    }
  }

export function* getDashboardSummary(action) {
  try {
    console.log('action.payload.filter', action.payload.filter);
    const response = yield call(request, APIEndpoints.GET_DASHBOARD_SUMMARY, {
      method: 'GET',
      payload: action.payload.filter,
    })
    yield put({
      type: ActionTypes.GET_DASHBOARD_SUMMARY_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_DASHBOARD_SUMMARY_FAILURE,
      payload: err.message
    })
  }
}

export function* approveCompanyAudit(action) {
  try {
      const { auditId, company, comment } = action.payload
      const response = yield call(request, APIEndpoints.APPROVE_COMPANY_AUDIT(company, auditId), {
          method: 'POST',
          payload: { audit_status_id: auditId, company_id: company, comment:comment}
      })
      yield put({
          type: ActionTypes.APPROVE_COMPANY_AUDIT_SUCCESS,
          payload: response,
      })
  } catch (err) {
      /* istanbul ignore next */
      yield put({
          type: ActionTypes.APPROVE_COMPANY_AUDIT_FAILURE,
          payload: err
      })
  }
}

export function* getTotalCompanies(action) {
  try {
    const response = yield call(request, APIEndpoints.GET_TOTAL_COMPANIES, {
      method: 'GET',
      payload: {...action.payload.filter}
    })
    yield put({
      type: ActionTypes.GET_TOTAL_COMPANIES_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_TOTAL_COMPANIES_FAILURE,
      payload: err.message
    })
  }
}

export function* companyDetails(action) {
  try {
    const { companyId } = action.payload
    const response = yield call(request, APIEndpoints.COMPANY_DETAILS(companyId), {
      method: 'GET',
    })
    yield put({
      type: ActionTypes.COMPANY_DETAILS_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.COMPANY_DETAILS_FAILURE,
      payload: err.message
    })
  }
}

export function* getApprovalFlow(action) {
  try {
    const { year, country  } = action.payload
    const response = yield call(request, APIEndpoints.GET_APPROVAL_FLOW(country, year), {
      method: 'GET',
    })
    yield put({
      type: ActionTypes.GET_APPROVAL_FLOW_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_APPROVAL_FLOW_FAILURE,
      payload: err.message
    })
  }
}

export function* updateApprovalFlow(action) {
  try {
      const { year, country, approvalFlow } = action.payload
      const apiEndpoint = APIEndpoints.UPDATE_APPROVAL_FLOW ()
      const response = yield call(request, apiEndpoint, {
          method: 'PUT',
          payload: { year : year, country : country, approval_flow : approvalFlow}
      })
      yield put({
          type: ActionTypes.UPDATE_APPROVAL_FLOW_SUCCESS,
          payload: response
      })
  } catch (err) {
      /* istanbul ignore next */
      yield put({
          type: ActionTypes.UPDATE_APPROVAL_FLOW_FAILURE,
          payload: err
      })
  }
}

export function* companyFunctionalitySetup(action) {
  try {
    const { companyId, payload  } = action.payload;

    const response = yield call(request, APIEndpoints.COMPANY_FUNCTIONALITY_SETUP(companyId), {
      method: 'POST',
      payload
    });

    yield put({
      type: ActionTypes.COMPANY_FUNCTIONALITY_SETUP_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.COMPANY_FUNCTIONALITY_SETUP_FAILURE,
      payload: err,
    });
  }
}

export function* functionalityView() {
  try {
    const response = yield call(request, APIEndpoints.FUNCTIONALITY_VIEW(), {
      method: 'GET',
    })

    yield put({
      type: ActionTypes.FUNCTIONALITY_VIEW_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.FUNCTIONALITY_VIEW_FAILURE,
      payload: err.message
    })
  }
}


export function* getFunctionalityData(action) {
  const { companyId } = action.payload
  try {
    const response = yield call(request, APIEndpoints.GET_FUNCTIONALITY_DATA(companyId), {
      method: 'GET',
    })

    yield put({
      type: ActionTypes.GET_FUNCTIONALITY_DATA_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_FUNCTIONALITY_DATA_FAILURE,
      payload: err.message
    })
  }
}

export function* getAdminAnnouncementList(action) {
  const { year, notification_type, notification_status } = action.payload
  try {
    const response = yield call(request, APIEndpoints.GET_ADMIN_ANNOUNCEMENT_LIST(year, notification_type, notification_status), {
      method: 'GET',
    })

    yield put({
      type: ActionTypes.GET_ADMIN_ANNOUNCEMENT_LIST_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ADMIN_ANNOUNCEMENT_LIST_FAILURE,
      payload: err.message
    })
  }
}

export function* addAdminAnnouncement(action) {
  try {
    const { payload  } = action.payload;

    const response = yield call(request, APIEndpoints.ADD_ADMIN_ANNOUNCEMENT(), {
      method: 'POST',
      payload
    });

    yield put({
      type: ActionTypes.ADD_ADMIN_ANNOUNCEMENT_SUCCESS,
      payload: response,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.ADD_ADMIN_ANNOUNCEMENT_FAILURE,
      payload: err,
    });
  }
}

export function* editAdminAnnouncement(action) {
  try {
      const { requestData } = action.payload
      const response = yield call(request, APIEndpoints.EDIT_ADMIN_ANNOUNCEMENT(requestData.id), {
          method: 'PUT',
          payload: requestData.payload
      })
      yield put({
          type: ActionTypes.EDIT_ADMIN_ANNOUNCEMENT_SUCCESS,
          payload: response
      })
  } catch (err) {
      /* istanbul ignore next */
      yield put({
          type: ActionTypes.EDIT_ADMIN_ANNOUNCEMENT_FAILURE,
          payload: err
      })
  }
}

export function* getAdminAnnouncement(action) {
  const { id } = action.payload
  try {
    const response = yield call(request, APIEndpoints.GET_ADMIN_ANNOUNCEMENT(id), {
      method: 'GET',
    })

    yield put({
      type: ActionTypes.GET_ADMIN_ANNOUNCEMENT_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ADMIN_ANNOUNCEMENT_FAILURE,
      payload: err.message
    })
  }
}

export function* getAdminAnnouncementChangelog(action) {
  const { id } = action.payload
  try {
    const response = yield call(request, APIEndpoints.GET_ADMIN_ANNOUNCEMENT_CHANGELOG(id), {
      method: 'GET',
    })

    yield put({
      type: ActionTypes.GET_ADMIN_ANNOUNCEMENT_CHANGELOG_SUCCESS,
      payload: response
    })
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_ADMIN_ANNOUNCEMENT_CHANGELOG_FAILURE,
      payload: err.message
    })
  }
}


export default function* root() {
  yield all([
    takeLatest(ActionTypes.GET_COMPANY_LIST, getCompanyList),
    takeLatest(ActionTypes.GET_COMPANY_DETAILS, getCompanyDetails),
    takeLatest(ActionTypes.GET_COMPANY_AUDIT_HISTORY, getCompanyAuditHistory),
    takeLatest(ActionTypes.GET_COMPANY_AUDIT_DETAILS, getCompanyAuditDetails),
    takeLatest(ActionTypes.APPROVE_COMPANY_AUDIT, approveCompanyAudit),
    takeLatest(ActionTypes.GET_DASHBOARD_SUMMARY, getDashboardSummary),
    takeLatest(ActionTypes.GET_TOTAL_COMPANIES, getTotalCompanies),
    takeLatest(ActionTypes.GET_APPROVAL_FLOW, getApprovalFlow),
    takeLatest(ActionTypes.UPDATE_APPROVAL_FLOW, updateApprovalFlow),
    takeLatest(ActionTypes.COMPANY_DETAILS, companyDetails),
    takeLatest(ActionTypes.COMPANY_FUNCTIONALITY_SETUP, companyFunctionalitySetup),
    takeLatest(ActionTypes.FUNCTIONALITY_VIEW, functionalityView),
    takeLatest(ActionTypes.GET_FUNCTIONALITY_DATA, getFunctionalityData),
    takeLatest(ActionTypes.GET_ADMIN_ANNOUNCEMENT_LIST, getAdminAnnouncementList),
    takeLatest(ActionTypes.ADD_ADMIN_ANNOUNCEMENT, addAdminAnnouncement),
    takeLatest(ActionTypes.EDIT_ADMIN_ANNOUNCEMENT, editAdminAnnouncement),
    takeLatest(ActionTypes.GET_ADMIN_ANNOUNCEMENT, getAdminAnnouncement),
    takeLatest(ActionTypes.GET_ADMIN_ANNOUNCEMENT_CHANGELOG, getAdminAnnouncementChangelog),
  ])
}
